import _ from "../../../../@lodash";

const ProjectModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "language",    
    progress: {
      development: 0,
      production: 0,
    },
    status: {
      development: "not_started",
      production: "not_started",
    },
    order: 0,
    user: "",
    manager: "",
    client: "",
    cor: "",
  });

export default ProjectModel;
